import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {PressureConfig, PressureConfigJson} from './pressure-config';
import {MeasureTypePressureConfig, MeasureTypePressureConfigJson} from './measure-type-pressure-config';

export type PressureIntervalConfigJson =  {
  min: PressureConfigJson;
  max: MeasureTypePressureConfigJson;
  liveMargin: number;
};

export class PressureIntervalConfig implements JsonConfigInterface<PressureIntervalConfigJson> {

  public readonly min: PressureConfig = new PressureConfig();
  public readonly max: MeasureTypePressureConfig = new MeasureTypePressureConfig();
  private _liveMargin: number = 0;

  constructor(json?: PressureIntervalConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get liveMargin(): number {
    return this._liveMargin;
  }

  public deserializeJson(json: PressureIntervalConfigJson): void {
    this.min.deserializeJson(json.min);
    this.max.deserializeJson(json.max);
    this._liveMargin = json.liveMargin;
  }
}
